import { BareFetcher, Key, SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR/useSWR';

export type UseArraySWROutput<T> = Omit<UseSWROutput<Array<T>>, 'data'> & {
  data: Array<T>;
};

export const useArraySWR = <T>(
  key: Key,
  fn?: BareFetcher<Array<T>>,
  config?: SWRConfiguration<Array<T>, Error>,
): UseArraySWROutput<T> => {
  const { data, ...rest } = useSWR<Array<T>>(key, fn, config);

  return {
    data: data ?? [],
    ...rest,
  };
};
